import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const PincodeContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PincodeProvider = ({ children }) => {
  const [currentPincode, setCurrentPincode] = useState(localStorage.getItem('pincode') || '247776');
  const [isDeliverable, setIsDeliverable] = useState(true);
  const [areaName, setAreaName] = useState('Shamli');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkPincode(currentPincode);
  }, []);

  const checkPincode = async (pincode) => {
    setLoading(true);
    try {
      const response = await axios.get(`${API}/pincodes/check/${pincode}`);
      setIsDeliverable(response.data.available);
      setAreaName(response.data.area || '');
      if (response.data.available) {
        localStorage.setItem('pincode', pincode);
        setCurrentPincode(pincode);
      }
      return response.data;
    } catch (error) {
      console.error('Failed to check pincode:', error);
      setIsDeliverable(false);
      setAreaName('');
      return { available: false, area: null };
    } finally {
      setLoading(false);
    }
  };

  const setPincode = async (pincode) => {
    const result = await checkPincode(pincode);
    if (result.available) {
      setCurrentPincode(pincode);
    }
    return result;
  };

  const value = {
    currentPincode,
    isDeliverable,
    areaName,
    loading,
    checkPincode,
    setPincode
  };

  return (
    <PincodeContext.Provider value={value}>
      {children}
    </PincodeContext.Provider>
  );
};

export const usePincode = () => {
  const context = useContext(PincodeContext);
  if (!context) {
    throw new Error('usePincode must be used within a PincodeProvider');
  }
  return context;
};
